import { render } from "./Domains.vue?vue&type=template&id=f6c11b72"
import script from "./Domains.vue?vue&type=script&lang=js"
export * from "./Domains.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__